import React from "react";
import { Link } from "react-router-dom";

// Section header with red tab + optional "view all"
export function SectionHeader({ title, titleHi, to, accent = "red" }) {
  return (
    <div className="flex items-end justify-between mb-5 border-b-2 border-black pb-0">
      <div className="flex items-baseline gap-3">
        <h2 className={`font-head font-bold text-2xl md:text-3xl uc ${accent === "black" ? "text-black" : ""}`}>
          <span className={accent === "black" ? "" : "text-r24-red"}>{title}</span>
        </h2>
        {titleHi && <span className="font-hindi text-gray-400 text-base hidden sm:inline">{titleHi}</span>}
      </div>
      {to && (
        <Link to={to} className="font-head font-semibold uc text-xs text-gray-600 hover:text-r24-red pb-1" data-testid={`viewall-${to}`}>
          View All →
        </Link>
      )}
    </div>
  );
}

export default function SectionBlock({ children, className = "" }) {
  return <section className={`max-w-7xl mx-auto px-4 py-8 md:py-10 ${className}`}>{children}</section>;
}
